import React from "react";

export default function AIAnalysis() {
  return (
    <div className="space-y-6">
      <h1 className="text-4xl font-bold">
        AI Market Analysis
      </h1>

      <div className="rounded-xl border border-white/10 p-8">

        <h2 className="text-2xl font-semibold">
          AI Analysis
        </h2>

        <ul className="mt-6 space-y-3 text-white/70">

          <li>✔ Technical Analysis</li>

          <li>✔ Fundamental Analysis</li>

          <li>✔ News Sentiment</li>

          <li>✔ Institutional Activity</li>

          <li>✔ Smart Money Flow</li>

          <li>✔ Risk Score</li>

          <li>✔ Buy / Hold / Sell</li>

        </ul>

      </div>
    </div>
  );
}

